import { graphql } from 'gatsby';
import React from 'react';
import { isBrowser } from '../../../utils';
import { Trustpilot as TrustpilotComponent } from '../../Trustpilot';
import { RecentlyViewedProperties } from '../../properties/RecentlyViewedProperties';

export const Trustpilot = ({ data, location, ...rest }) => {


  return (
    <>
      <TrustpilotComponent {...data} {...rest} />
    </>
  );
};

export const TrustpilotQuery = graphql`
  fragment Trustpilot on KFH_UmbracoTrustPilotComponentType {
    title
    tag
  }
`;
